import * as firebase from "firebase/app";
import users from '../api/user'
import userUtils from '@/utils/UserUtils'


/**
 * Set user attributes to vue state derived from Firebase User Meta
 * 
 */
export function setUserAttributes(){
    return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                firebase.auth().currentUser.getIdTokenResult(true)
                    .then((result) => {
                        let userAttribute = {
                            name: user.displayName,
                            email: user.email,
                            phoneNumber: user.phoneNumber,
                            photoURL: user.photoURL,
                            emailVrified: user.emailVerified,
                            providerData: user.providerData,
                            firebaseId: user.uid,
                            signInProvider: result.signInProvider,
                            token: result.token,
                            tokenData: result
                        }

                        users.getUserMeta(result.token)
                            .then(response => {
                                resolve({userAttribute:userAttribute, userMeta:response.data[0]})
                            })
                            .catch(error => {
                                reject({code: error.response.status, message: error.response.data.message});
                            })
                    })
                    .catch((error) => {
                        reject('No user is signed in.');
                    });
            } else {
              reject('No user is signed in.');
            }
          });        
    })
}


/**
 * Forgot Password, Send Password Reset Email
 * @param {*} email 
 */
export function sendPasswordReset(email, lang) {
    return new Promise((resolve, reject) => {
        firebase.auth().languageCode = lang

        firebase.auth().sendPasswordResetEmail(email)
            .then((res) =>  {
                resolve(res);
            }).catch((error) => {
                reject(error)
            });
    })
}


/**
 * Cahnge user current email address
 * @param {*} new_email 
 */
export function changeCurrentEmailAddress(new_email) {
    return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(user => {
            if (!user) 
                reject({code:'generel/error', message: 'User Not Found or not signed in'});
            if (!new_email)
                reject({code:'generel/error', message: 'You must have to input your new email address.'});
    
            user.updateEmail(new_email).then(result => {
                // console.log(result) // undefined
                // An automated email sent to previous email for security purpose and reset purpose
                // For verify new email, we should sent email verification email 
                
                firebase.auth().currentUser.sendEmailVerification().then(() => {
                    resolve('Email Verification Sent!');
                }).catch(err => {
                    reject(err)
                })
            }).catch(error => {
                reject(error)
            });
        })
    })
}


/**
 * Change old password
 * To set a user's password, the user must have signed in recently. See Re-authenticate a user.
 */
export function updateUserPassword(newPassword) {
    return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(user => {
            if (!user) {
                reject({code:'generel/error', message: 'User Not Found or not signed in'});
            }
            if (!newPassword) {
                reject({code:'generel/error', message: 'Please input a valid password.'});
            }
    
            var user = firebase.auth().currentUser;

            user.updatePassword(newPassword)
                .then(password => {
                    resolve('Password resete success!')
                })
                .catch(error => {
                    reject(error)
                });
    
        });
    })
}


/**
 * Sign out user currecnt session
 */
export function signOutUser(){
    return new Promise((resolve, reject) => {
        firebase.auth().signOut()
            .then(() => {
                window.localStorage.removeItem('__usrData');
                resolve()
            }).catch((error) => {
                reject(error)
            });                
    })    
}


/**
 * Set Firebase Languge 
 */
export function changeFirebaseLanguage(langName){
    firebase.auth().languageCode = userUtils.uniStyleLang(langName);
}


/**
 * get New ID token & set it to state 
 */
export function getNewToken(){
    return new Promise((resolve, reject) => {
        firebase.auth().currentUser.getIdTokenResult(true)
            .then((result) => {
                resolve(result)
            })
            .catch((error) => {
                reject({code: 'user/not-authenticate', message: error.message || 'No user is signed in.'});
            })
    })
}


/**
 * Delete an user from Firebase 
 */
export function deleteUserFromFirebase(){
    return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged( user => {
            if (!user) reject({code:'generel/error', message: 'User Not Found or not signed in'});

            firebase.auth().currentUser.delete()
                .then((result) => {
                    // console.log(result) // undefined
                    resolve('User deleted!');
                }).catch((error) =>  {
                    // console.log(error)
                    reject(error)
                });
        })
    })
}


/**
 * Get current authenticiated token
 */
export function getCurrentAuthToken(){
    return new Promise((resolve, reject) => {
        firebase.auth().currentUser.getIdToken()
            .then((result) => {
                resolve(result)
            })
            .catch((error) => {
                reject({code: 'user/not-authenticate', message: error.message || 'No user is signed in.'});
            })
    })    
}


// WEBPACK FOOTER //
// ./src/auth/user-meta.js